import * as React from 'react';
import { Popover } from '@base-ui-components/react/popover';
import { Box, TextField, Typography } from "@mui/material";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultButton from '../buttons/DefaultButton';
import ForgotPassword from './ForgotPassword';
import { apiFetch } from '../../../services/api';
import { useAuth } from '../../../services/auth';
import { postAuthDestination } from '../../../services/postAuthRedirect';
import { colors } from '../../../theme';
import { pillTriggerStyle, popupStyle, positionerStyle, closeButtonStyle, backdropStyle } from '../buttons/triggerStyles';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { onAuthenticated } = useAuth();

    const handleSubmit = () => {
        if (!email || !password) {
            setError('All fields are required.');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setError('Please enter a valid email address.');
            return;
        }

        setError('');
        apiFetch('/v1/users/login', {
            method: 'POST',
            body: JSON.stringify({ username: email, password }),
        })
            .then(response => response.json())
            .then(data => {
                // The cookie is already set by the response; this just re-checks who we are.
                onAuthenticated();
                navigate(postAuthDestination());
            })
            .catch(err => {
                console.error('Error during login:', err);
                setError('Login failed. Please check your credentials.');
            });
    };

    return (
        <Popover.Root>
            <Popover.Trigger style={pillTriggerStyle('ghost')}>
                Log in
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Backdrop style={backdropStyle} />
                <Popover.Positioner style={positionerStyle}>
                    <Popover.Popup style={popupStyle}>
                        <Popover.Close aria-label="Close" style={closeButtonStyle}>
                            ✕
                        </Popover.Close>

                        <Typography variant="h4" sx={{ mb: 0.5 }}>Log in</Typography>
                        <Typography variant="body2" sx={{ mb: 3 }}>
                            Pick up where your playlists left off.
                        </Typography>

                        <TextField
                            label="Email"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ mb: 1.5 }}
                        />
                        <TextField
                            label="Password"
                            type="password"
                            fullWidth
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            sx={{ mb: 1.5 }}
                        />

                        {error && (
                            <Typography sx={{ color: colors.danger, fontSize: 13, mb: 1.5 }}>
                                {error}
                            </Typography>
                        )}

                        <Box sx={{ mt: 2 }}>
                            <DefaultButton text="Log in" onClick={handleSubmit} fullWidth />
                        </Box>

                        <Box sx={{ mt: 2, textAlign: "center" }}>
                            <ForgotPassword />
                        </Box>
                    </Popover.Popup>
                </Popover.Positioner>
            </Popover.Portal>
        </Popover.Root>
    );
}
